import initMinigallery from './packages/package-minigallery';
import { initAccordions } from './utils';

window.com.parkside.overview = {};
window.com.parkside.overview.init = function () {
  initAccordions();
  initMinigallery();
};
